import {
  LinkedinShareButton,
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
} from 'react-share';

import {
  FaFacebookF,
  FaXTwitter,
  FaLinkedinIn,
  FaEnvelope,
} from 'react-icons/fa6';

export default function SocialButtons({ shareData, keyword, shareUrl }) {
  const title = `Check out this ${keyword} Report on CoherentMI !`;

  return (
    <div className="flex bg-white rounded-xl justify-evenly p-2">
      <LinkedinShareButton
        url={shareUrl}
        summary={shareData}
        title={title}
        source={'www.coherentmi.com'}
      >
        <FaLinkedinIn size={30} className="mx-auto mb-2" />
        <span className="ms-0">Linkedin</span>
      </LinkedinShareButton>

      <TwitterShareButton
        url={shareData}
        title={title}
        source={'www.coherentmi.com'}
      >
        <FaXTwitter size={30} className="mx-auto mb-2" />
        <span>Twitter</span>
      </TwitterShareButton>

      <EmailShareButton
        url={shareData}
        subject={title}
        body="Check this out: "
        source={'www.coherentmi.com'}
      >
        <FaEnvelope size={30} className="mx-auto mb-2" />
        <span>Email</span>
      </EmailShareButton>

      <FacebookShareButton
        url={shareUrl}
        quote={title}
        hashtag={`#${keyword} #coherentmi`}
        source={'www.coherentmi.com'}
      >
        <FaFacebookF size={30} className="mx-auto mb-2" />
        <span>Facebook</span>
      </FacebookShareButton>
    </div>
  );
}
